import React from 'react'
import {component_tool} from '../../../../../tool'

let {WizDataTable, WizIcon, WizButton, WizDivider} = component_tool;

export default (self) => {
  return [
    {
      title: 'id',
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'personId',
      name: 'personId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'delFlag',
      name: 'delFlag',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'searchUserName',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {}
    },
    {
      title: '姓名',
      name: 'searchFullName',
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {}
    },
    {
      title: '手机号',
      name: 'searchMobile',
      searchItem: {}
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {}
    },
    {
      title: '邮箱',
      name: 'searchEmail',
      searchItem: {}
    },
    {
      title: '邮箱',
      name: 'email',
      tableItem: {},
      formItem: {}
    },
    {
      title: '状态',
      name: 'disabled',
      dict: [
        {code: 0, codeName: '激活'},
        {code: 1, codeName: '禁用'},
      ],
      tableItem: {},
      searchItem: {
        type: 'select',
        // initialValue: 1
      }
    }
  ]
}
